export default "__VITE_ASSET__CHW7uzp0__"